import React from 'react';
import { connect } from 'react-redux';
import HorizontalCharsTab from '../../components/HorizontalCharsTab';
import ProcessMaturityModel from '../../components/ProcessMatuirityModel';
import ProjectPrioritizationGrid from '../../components/ProjectPrioritizationGrid';
import RegionalComparison from '../../components/RegionalComparison';
import { ReactComponent as BenchmarkFlagShort } from '../../static/assets/benchmark-flag-short.svg';
import { ReactComponent as FullCircle } from '../../static/assets/fx-circle-2.svg';
import { ReactComponent as EmptyCircle } from '../../static/assets/fx-circle-1.svg';
import { ReactComponent as LeftLeftButton } from '../../static/assets/shape-pmm-q.svg';
import { ReactComponent as LeftCenterButton } from '../../static/assets/shape-pmm.svg';
import { ReactComponent as RightCenterButton } from '../../static/assets/shape-ppg.svg';
import { ReactComponent as RightRightButton } from '../../static/assets/shape-rc.svg';
import { ReactComponent as HomeIcon } from '../../static/assets/home.svg';
import { ReactComponent as ConfigIcon } from '../../static/assets/config.svg';
import { ReactComponent as BackIcon } from '../../static/assets/back.svg';
import { manipulateLiValue, manipulateBoiValue, checkIfActiveDataSet } from '../../utils/dataSet/actions';
import { resetAll } from '../../utils/filter/actions';
import {SliderFlags} from "../../components/Sliders/sliderFlags";
import {PREFIX_URL} from "../../constants";

class Results extends React.Component {
  state = {
    activeMainTab: "PMM Questionnaire",
    showInfoBox: null,
    rangesBoiUpperInfoBox: false,
    rangesLeadBottomInfoBox: false,
    isMounted: true,
    'filter-history-popover': false,
  }

  componentDidMount() {
    this.props.checkIfActiveDataSet();
  }

  handleItemClick = (event) => {
    const name = event.currentTarget.getAttribute('name');
    let newPath;
    if (name === 'start') {
      newPath = PREFIX_URL;
    } else if (name === 'back') {
      this.props.history.goBack();
      return;
    } else {
        newPath = `${PREFIX_URL}${name}`;
    }
    if (this.props.history.location.pathname !== newPath) {
      this.setState({ isMounted: false });
      this.awaitBeforeHistoryPush(newPath, 2000, this.props.history.push);
    }
  }

  handleInfoClick = (event) => {
    const id = event.currentTarget.getAttribute('id');
    this.setState({ [id]: !this.state[id] });
  }

  handleLeftUpperPanelInfoClick = (event) => {
    event.stopPropagation();
    const id = event.currentTarget.getAttribute('id');
    if (this.state.showInfoBox === id) {
      this.setState({
        showInfoBox: null,
        rangesBoiUpperInfoBox: false,
      });
    } else {
      this.setState({
        showInfoBox: id,
        rangesBoiUpperInfoBox: true,
      });
    }
    if (id === 'filter-history-popover' && this.state['filter-history-popover']) {
      this.setState({ 'filter-history-popover': false });
    } else if (id === 'filter-history-popover') {
      this.setState({ 'filter-history-popover': true });
    }
  }

  handleLeftBottomPanelInfoClick = (event) => {
    event.stopPropagation();
    const id = event.currentTarget.getAttribute('id');
    if (this.state.showInfoBox === id) {
      this.setState({
        showInfoBox: null,
        rangesLeadBottomInfoBox: false
      });
    } else {
      this.setState({
        showInfoBox: id,
        rangesLeadBottomInfoBox: true
      });
    }
    if (id === 'filter-history-popover' && this.state['filter-history-popover']) {
      this.setState({ 'filter-history-popover': false });
    } else if (id === 'filter-history-popover') {
      this.setState({ 'filter-history-popover': true });
    }
  }

  handleResetClick = (event) => {
    event.stopPropagation();
    this.setState({ isMounted: false, 'filter-history-popover': false });
    this.awaitBeforeCallback(2000, this.props.resetAll);
  }

  awaitBeforeCallback(time, callback) {
    setTimeout(function() {
      callback();
    }, time)
  }

  awaitBeforeHistoryPush(newPath, time, callback) {
    setTimeout(function() {
      callback(newPath);
    }, time)
  }

  rangeChange = (e) => {
    const id = e.currentTarget.getAttribute('id');
    const category = e.currentTarget.getAttribute('category');
    const min = e.currentTarget.getAttribute('min');
    const max = e.currentTarget.getAttribute('max');
    const { valueAsNumber, name } = e.target;
    this.setState({ [name]: valueAsNumber, ['min-'+name]: min, ['max-'+name]: max });
    if (category === 'li') {
      this.props.manipulateLiValue(id, valueAsNumber, );
    } else {
      this.props.manipulateBoiValue(id, valueAsNumber);
    }
  }

  getPopoverOffset(newPoint) {
    switch(true){
      case (newPoint < .11359):
        return '-24.84%';
      case (newPoint > .1136 && newPoint <= .1931):
        return '-27.11%';
      case (newPoint > .1931 && newPoint <= .231):
        return '-27.093%';
      case (newPoint > .231 && newPoint <= .2851):
        return '-27.393%';
      case (newPoint > .2851 && newPoint <= .339):
        return '-27.793%';
      case (newPoint > .339 && newPoint <= .3915):
        return '-28.193%';
      case (newPoint > .3915 && newPoint <= .4492):
        return '-28.253%';
      case (newPoint > .4492 && newPoint < .5):
        return '-29.593%';
      case (newPoint > .51 && newPoint <= .62):
        return '-30.193%';
      case (newPoint > .62 && newPoint <= .75):
        return '-31.793%';
      case (newPoint > .75 && newPoint <= .89):
        return '-33.693%';
      case (newPoint > .89):
        return '-34.565%';
      default:
        return '-29.97%';
    }
  }

  getBenchmarkOffset(newPoint) {
    switch(true){
      case (newPoint < .11359):
        return '1%';
      case (newPoint > .89):
        return '-1.765%';
      default:
        return '0';
    }
  }

  renderRangesBoi() {
    return (
       this.props.boiRanges.map((range, index) => (
        <div
            className="row range-data"
            style={this.props.boiRangesChecked.includes(range['id']) ? {} : {display: 'None'}}
            key={index}
        >
          <div className="col-5 first-col">
            <div>
              {range['label']} {range['unit_prefix']}
              {
                range['comment']
                    ? <><i id={range['id']} className="fas fa-info-circle" onClick={this.handleLeftUpperPanelInfoClick}/></>
                    : null
              }
              {
                // this.state.showInfoBox && this.state.upperInfoBox ?
                <div
                    className="info-popover"
                    style={
                      this.state.showInfoBox === range['id'] && this.state.rangesBoiUpperInfoBox
                          ? {opacity: 1}
                          : {opacity: 0, display: 'none'}
                    }
                >
                  <h3>{range['label']} {range['unit_prefix']}</h3>
                  {range['comment']}
                </div>
                // :null
              }

            </div>
          </div>
          <div className="col range">
            <div className="custom-range-outer">
              <div
                  className="range-popover"
                  key={this.state[`boi-${range['label']}`]}
                  style={
                    this.state[`boi-${range['label']}`] !== undefined
                        ? {
                          left: (
                              (this.state[`boi-${range['label']}`] - this.state[`min-boi-${range['label']}`]) /
                              (this.state[`max-boi-${range['label']}`] - this.state[`min-boi-${range['label']}`])
                              * 100) + '%',
                          marginLeft: this.getPopoverOffset(this.state[`boi-${range['label']}`] / range['max_value'])
                        }
                        : {
                          left: (
                              (range['value'] - range['min_value']) /
                              (range['max_value'] - range['min_value'])
                              * 100) + '%',
                          marginLeft: this.getPopoverOffset(range['value'] / range['max_value'])
                        }
                  }
              >
                <span>
                  {
                    this.state[`boi-${range['label']}`] !== undefined
                        ? this.state[`boi-${range['label']}`]
                        : range['value']}&nbsp;{range['unit_prefix']
                }
                </span>
              </div>

             <SliderFlags
                 range={range}
                 getBenchmarkOffset={this.getBenchmarkOffset.bind(this)}
             />

              <input
                  id={range['id']}
                  category='boi'
                  min={range['min_value']}
                  max={range['max_value']}
                  name={`boi-${range['label']}`}
                  step="0.01"
                  defaultValue={isNaN(range['value']) ? range['as_is'] : range['value']}
                  onChange={this.rangeChange}
                  type="range"
                  className={`custom-range ${range['is_decreasing'] ? 'decreasing' : ''}`}
              />
            </div>
          </div>
        </div>))
        );
  }

  renderRangesLead() {
    return (
      this.props.leadRanges.map((range, index) => (
        <div className="row range-data" key={index}>

          <div className="col-5 first-col">
            <div>{range['label']} {range['unit_prefix']}
              {
                range['comment'] &&
                    <>
                      <i id={range['id']} className="fas fa-info-circle" onClick={this.handleLeftBottomPanelInfoClick} />
                    </>
              }
              <div
                  className="info-popover"
                  style={
                    this.state.showInfoBox === range['id'] && this.state.rangesLeadBottomInfoBox
                        ? {opacity: 1}
                        : {opacity: 0, display: 'none'}
                  }
              >
                <h3>{range['label']} {range['unit_prefix']}</h3>
                {range['comment']}
              </div>
            </div>
          </div>
          <div className="col range">
            <div className="custom-range-outer">
              <div
                className="range-popover"
                key={this.state[`lead-${range['label']}`]}
                style={
                  this.state[`lead-${range['label']}`] !== undefined
                      ? {
                        left: (
                            (this.state[`lead-${range['label']}`] - this.state[`min-lead-${range['label']}`]) /
                            (this.state[`max-lead-${range['label']}`] - this.state[`min-lead-${range['label']}`])
                            * 100) + '%',
                        marginLeft: this.getPopoverOffset(this.state[`lead-${range['label']}`] / range['max_value'])
                      }
                      : {
                        left: (
                            (range['value'] - range['min_value']) /
                            (range['max_value'] - range['min_value'])
                            * 100) + '%',
                        marginLeft: this.getPopoverOffset(range['value'] / range['max_value'])
                      }
                }
              >
                <span>
                  {
                    this.state[`lead-${range['label']}`] !== undefined
                        ? this.state[`lead-${range['label']}`]
                        : range['as_is'] }&nbsp;{range['unit_prefix']
                  }
                </span>
              </div>

              <SliderFlags
                  range={range}
                  getBenchmarkOffset={this.getBenchmarkOffset.bind(this)}
              />

              <input
                id={range['id']}
                category='li'
                min={range['min_value']}
                max={range['max_value']}
                name={`lead-${range['label']}`}
                step="0.01"
                defaultValue={isNaN(range['value']) ? range['as_is'] : range['value']}
                onChange={this.rangeChange}
                type="range"
                className={`custom-range ${range['is_decreasing'] ? 'decreasing' : ''}`}
              />
            </div>
          </div>
        </div>))
    );
  }

  mainTabHandleClick = (event) => {
    const name = event.currentTarget.getAttribute('name');
    this.setState({ activeMainTab: name });
  }

  render() {
    const { activeMainTab } = this.state;
    return (
      <div className={`w-100 container-fluid h-100 results-container ${this.state.isMounted ? '' : 'unmounting'}`}>
        <FullCircle className="circle-icon full-medium left-center" />
        <FullCircle className="circle-icon full-small left-bottom" />
        <FullCircle className="circle-icon full-medium right-bottom" />
        <FullCircle className="circle-icon full-small right-center" />
        <EmptyCircle className="circle-icon empty-big top-center" />
        <EmptyCircle className="circle-icon empty-small right-top" />
        <EmptyCircle className="circle-icon empty-small right-center" />
        <EmptyCircle className="circle-icon empty-big bottom-right" />
        <EmptyCircle className="circle-icon empty-medium bottom-center" />
        <EmptyCircle className="circle-icon empty-small bottom-left" />
        <BackIcon onClick={this.handleItemClick} name="back" className="back-button navigation-button" />
        <ConfigIcon onClick={this.handleInfoClick} id="filter-history-popover" className="config-button navigation-button" />
        <div className="info-popover history-popover" style={this.state["filter-history-popover"] ? {opacity: 1} : {opacity: 0, display: 'none'} } >
          <p>Offering:</p>
          <p className="name">{this.props.activeOffering}</p>
          <p>Sub-Offering:</p>
          <p className="name">{this.props.activeSubOffering}</p>
          <p>Process:</p>
          <p className="name">{this.props.activeProcess}</p>
          <p>Business Region:</p>
          <p className="name">{this.props.activeRegion}</p>
          <button onClick={this.handleResetClick} className="btn reset-btn btn-block">Reset</button>
        </div>
        <HomeIcon onClick={this.handleItemClick} name="basic-configuration" className="home-button navigation-button" />
        <div className="row h-100">
          <div className="col-4">
            <div className="h-50 container-fluid boi-box left-box">
              <div className="box-header-container">
                <p className="box-header">
                  Business Outcome Indicators
                </p>
              </div>
              <div className="container-fluid ranges table">
                <div className="head row">
                  <div className="col-5 first-col"><div>Particulars</div></div>
                  <div className="col range"><div>As-is Selector</div></div>
                  <div className="benchmark-top-container">
                    <span>Benchmark</span>
                    <BenchmarkFlagShort />
                  </div>
                </div>
                <div className="ranges-scroll-container">
                  { this.renderRangesBoi() }
                </div>
              </div>
            </div>
            <div className="h-50 container-fluid lead-box left-box">
              <div className="box-header-container">
                <p className="box-header">
                  Lead Indicators
                </p>
              </div>
              <div className="container-fluid ranges table">
                <div className="head row">
                  <div className="col-5 first-col"><div>Particulars</div></div>
                  <div className="col range"><div>As-is Selector</div></div>
                  <div className="benchmark-top-container">
                    <span>Benchmark</span>
                    <BenchmarkFlagShort />
                  </div>
                </div>
                <div className="ranges-scroll-container">
                  { this.renderRangesLead() }
                </div>
              </div>
            </div>
          </div>
          <div className="col-8 h-100">
            <div className="container-fluid ranges-container results-box">
              <div className="main-header-container">
                <h1 className="main-header">
                  <span className="header-border header-border-left"></span>
                    Process Maturity Matrix
                  <span className="header-border header-border-right"></span>
                </h1>
              </div>
              <div className="secondary-header-container">
                <h2 className="secondary-header">
                  PMM Results
                </h2>
              </div>
              <div
                className={`left-left-button tab-button ${activeMainTab === "PMM Questionnaire" ? 'active' : ''}`}
                name="PMM Questionnaire"
                onClick={this.mainTabHandleClick}
              >
                <LeftLeftButton />
                <p>PMM Assessment</p>
              </div>
              <div
                className={`left-center-button tab-button ${activeMainTab === "Process Matuirity Model" ? 'active' : ''}`}
                name="Process Matuirity Model"
                onClick={this.mainTabHandleClick}
              >
                <LeftCenterButton />
                <p>Gap Report</p>
              </div>

              <div
                className={`right-center-button tab-button ${activeMainTab === "Project Prioritization Grid" ? 'active' : ''}`}
                name="Project Prioritization Grid"
                onClick={this.mainTabHandleClick}
              >
                <RightCenterButton />
                <p>Project Prioritization Grid</p>
              </div>

              <div
                className={`right-right-button tab-button disabled`}
                // className={`right-right-button tab-button ${activeMainTab === "Regional Comparison" ? 'active' : ''}`}
                name="Regional Comparison"
                // onClick={this.mainTabHandleClick}
              >
                <RightRightButton />
                <p>Regional Comparison</p>
              </div>
              <div className="tabs-content-container">
                {(() => {
                  switch (activeMainTab) {
                  case 'Process Matuirity Model': return <ProcessMaturityModel data={this.props.pmmQuestionnaireRanges} />;
                  case 'Project Prioritization Grid':
                    return <ProjectPrioritizationGrid data={this.props.pmmmPrioritizationGrid} />;
                  case 'Regional Comparison':
                    return <RegionalComparison
                        data={this.props.regionalComparisonData}
                        crossIndustry = {this.props.regionalComparsionCrossIndustry}
                        sameIndustry = {this.props.regionalComparsionSameIndustry}
                    />;
                  default: return <HorizontalCharsTab data={this.props.pmmQuestionnaireRanges} />;
                  }
                })()}
              </div>
              <div
                className="lead-footer basic-footer footer cursor-pointer"
                name="basic-configuration"
                onClick={this.handleItemClick}
              >
                <p>Basic Configurations</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    boiRanges: state.dataSet.activeDataSet.boiRanges,
    leadRanges: state.dataSet.activeDataSet.leadRanges,
    boiRangesChecked: state.dataSet.activeDataSet.boiRangesChecked,
    leadRangesChecked: state.dataSet.activeDataSet.leadRangesChecked,
    pmmQuestionnaireRanges: state.dataSet.activeDataSet.pmmQuestionnaireRanges,
    pmmmPrioritizationGrid: state.dataSet.activeDataSet.pmmmPrioritizationGrid,
    regionalComparisonData: state.dataSet.activeRegionalComparison,
    regionalComparisonCrossIndustry: state.dataSet.activeDataSet.regionalComparsionCrossIndustry,
    regionalComparisonSameIndustry: state.dataSet.activeDataSet.regionalComparsionSameIndustry,
    activeOffering: state.filter.activeOffering,
    activeSubOffering: state.filter.activeSubOffering,
    activeProcess: state.filter.activeProcess,
    activeRegion: state.filter.activeRegion,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    manipulateLiValue(chartId, value) {
      dispatch(manipulateLiValue(chartId, value));
    },
    manipulateBoiValue(chartId, value) {
      dispatch(manipulateBoiValue(chartId, value));
    },
    checkIfActiveDataSet() {
      dispatch(checkIfActiveDataSet());
    },
    resetAll() {
      dispatch(resetAll());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Results);
